import { useState, useEffect } from 'react';
import {
  getHighScores,
  addHighScore,
  isHighScore,
  getSettings,
  saveSettings,
  updateSetting as updateStoredSetting,
  saveGameSession,
  loadGameSession,
  clearGameSession,
} from '../utils/storage';

/**
 * Hook for managing high scores
 */
export function useHighScores() {
  const [highScores, setHighScores] = useState([]);

  useEffect(() => {
    setHighScores(getHighScores());
  }, []);

  const saveScore = (scoreEntry) => {
    const updatedScores = addHighScore(scoreEntry);
    setHighScores(updatedScores);
    return updatedScores;
  };

  const checkIsHighScore = (score) => {
    return isHighScore(score);
  };

  return {
    highScores,
    saveScore,
    checkIsHighScore,
  };
}

/**
 * Hook for managing game settings
 */
export function useSettings() {
  const [settings, setSettings] = useState(() => getSettings());

  const updateSetting = (key, value) => {
    const updated = updateStoredSetting(key, value);
    setSettings(updated);
  };

  const toggleSound = () => {
    updateSetting('soundEnabled', !settings.soundEnabled);
  };

  const toggleAnimations = () => {
    updateSetting('animationsEnabled', !settings.animationsEnabled);
  };

  return {
    settings,
    updateSetting,
    toggleSound,
    toggleAnimations,
  };
}

/**
 * Hook for managing game session persistence
 */
export function useGameSession(gameState, isPlaying) {
  // Auto-save game session when playing
  useEffect(() => {
    if (!isPlaying) return;

    const saveInterval = setInterval(() => {
      saveGameSession(gameState);
    }, 10000); // Save every 10 seconds

    return () => clearInterval(saveInterval);
  }, [isPlaying, gameState]);

  const loadSession = () => {
    return loadGameSession();
  };

  const clearSession = () => {
    clearGameSession();
  };

  return {
    loadSession,
    clearSession,
  };
}
